module.exports = __webpack_public_path__ + "components/outside-promo-page/static/mountainbikers-529dca09adde06e523886798f2aeaa32.webp";